// extracted by mini-css-extract-plugin
export default {"wrapper":"AboutUnit_wrapper__gt6pm","date":"AboutUnit_date__8eOrM","twoLevel":"AboutUnit_twoLevel__5wTna"};